import React from "react";
import "./Dialog.scss";
import Button from "../../jscomponents/Button/Button";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import LunaLink from "../../jscomponents/LunaLink/LunaLink"
import {checkAndSet} from  "../../utils/checkForDangerouslySet";

interface DialogProps {
  isOpen: boolean;
  variant: string;
  title: string;
  content: string;
  loadingText?: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
  onCloseButtonClick?: () => void;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  contentWithLink?: string;
  contentLink?: string;
  contentLinkText?: string;  
}

const Dialog = (props: DialogProps) => {
  const {
    isOpen,
    variant,
    title,
    content,
    loadingText,
    primaryButtonText,
    secondaryButtonText,
    onCloseButtonClick,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    contentWithLink,
    contentLink,
    contentLinkText,
  } = props;

  const Close = () => {
    if (onCloseButtonClick) {
      return (
        <button
          className="ter-dialog__close"
          onClick={onCloseButtonClick}
          aria-label="Close Dialog"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M15.2499 5.58762C15.1728 5.51037 15.0813 5.44908 14.9805 5.40726C14.8797 5.36544 14.7716 5.34392 14.6624 5.34392C14.5533 5.34392 14.4452 5.36544 14.3444 5.40726C14.2436 5.44908 14.152 5.51037 14.0749 5.58762L9.99994 9.65429L5.92494 5.57929C5.84779 5.50214 5.7562 5.44094 5.6554 5.39918C5.55459 5.35743 5.44655 5.33594 5.33744 5.33594C5.22833 5.33594 5.12029 5.35743 5.01949 5.39918C4.91869 5.44094 4.82709 5.50214 4.74994 5.57929C4.67279 5.65644 4.61159 5.74803 4.56984 5.84884C4.52808 5.94964 4.50659 6.05768 4.50659 6.16679C4.50659 6.2759 4.52808 6.38394 4.56984 6.48474C4.61159 6.58554 4.67279 6.67714 4.74994 6.75429L8.82494 10.8293L4.74994 14.9043C4.67279 14.9814 4.61159 15.073 4.56984 15.1738C4.52808 15.2746 4.50659 15.3827 4.50659 15.4918C4.50659 15.6009 4.52808 15.7089 4.56984 15.8097C4.61159 15.9105 4.67279 16.0021 4.74994 16.0793C4.82709 16.1564 4.91869 16.2176 5.01949 16.2594C5.12029 16.3011 5.22833 16.3226 5.33744 16.3226C5.44655 16.3226 5.55459 16.3011 5.6554 16.2594C5.7562 16.2176 5.84779 16.1564 5.92494 16.0793L9.99994 12.0043L14.0749 16.0793C14.1521 16.1564 14.2437 16.2176 14.3445 16.2594C14.4453 16.3011 14.5533 16.3226 14.6624 16.3226C14.7716 16.3226 14.8796 16.3011 14.9804 16.2594C15.0812 16.2176 15.1728 16.1564 15.2499 16.0793C15.3271 16.0021 15.3883 15.9105 15.43 15.8097C15.4718 15.7089 15.4933 15.6009 15.4933 15.4918C15.4933 15.3827 15.4718 15.2746 15.43 15.1738C15.3883 15.073 15.3271 14.9814 15.2499 14.9043L11.1749 10.8293L15.2499 6.75429C15.5666 6.43762 15.5666 5.90429 15.2499 5.58762Z" fill="#252A2E"/>
          </svg>
        </button>        
      )
    }
    return null;
  }
  const Buttons = ({ variant }: { variant: string }) => {
    if (variant === "primary") {
      return <Button text={primaryButtonText} onClick={onPrimaryButtonClick} />;
    } else if (variant === "secondary") {
      return (
        <div className="ter-dialog__buttons">
          <Button text={secondaryButtonText} onClick={onSecondaryButtonClick} />
          <Button
            text={primaryButtonText}
            className="ter-button--primary--2"
            onClick={onPrimaryButtonClick}
          />
        </div>
      );
    } else {
      return null;
    }
  };
  return (
    <div className={`${isOpen ? "ter-dialog__overlay" : ""}`}>
      <div
        className={`ter-dialog ${
          isOpen ? "ter-dialog--opened" : "ter-dialog--closed"
        }`}
      >
        <Close />
        {variant === "loading" && (
          <div className="ter-dialog-loading__section">
            <LoadingSpinner />
            {loadingText && (
              <span className="ter-dialog-loading__text">{loadingText}</span>
            )}
          </div>
        )}
        {title && <h6 className="ter-dialog__title">{title}</h6>}
        {content && checkAndSet(content, "ter-dialog__content", null, null, true)}
        {contentWithLink && contentLink && contentLinkText && (
          <p className="ter-dialog__content">
            {contentWithLink} <LunaLink className="ter-dialog__content--link" to={contentLink} >{contentLinkText}</LunaLink>
          </p>
        )}
        <Buttons variant={variant} />
      </div>
    </div>
  );
};

export default Dialog;
